import allPageStores from './pageStores/allPageStores';
import allProjectStores from './projectStores/allProjectStores';
import allUtilsStores from './utilStores/allUtilsStores';

const appStores = [...allUtilsStores, ...allPageStores, ...allProjectStores];
export default appStores;
